module.exports = __webpack_public_path__ + "static/media/create-bg.b67671fd.png";